<template>
	<div>
		<b-row>
			<b-col>
				<h4 class="avoid-page-break-after">Race</h4>
			</b-col>
		</b-row>
		<b-row class="print-row mt-3" v-for="(ability, abilityID) in Character.Bio.Race.Properties" :key="'details-ability-racial-'+abilityID">
			<b-col cols="2">
				<strong>{{ability.Name}}</strong>
			</b-col>
			<b-col cols="10" class="pre">
				{{ability.Description}}
			</b-col>
		</b-row>
	</div>
</template>

<script>
export default {
	computed: {
		Character: function() {
			return this.$store.state.Character
		}
	}
}
</script>

<style scoped>

</style>